import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    botCommandsAdminControllerCreateBotCommandV1: build.mutation<
      BotCommandsAdminControllerCreateBotCommandV1ApiResponse,
      BotCommandsAdminControllerCreateBotCommandV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/bot-commands`,
        method: 'POST',
        body: queryArg.createBotCommandBody,
      }),
    }),
    botCommandsAdminControllerListBotCommandsV1: build.query<
      BotCommandsAdminControllerListBotCommandsV1ApiResponse,
      BotCommandsAdminControllerListBotCommandsV1ApiArg
    >({
      query: () => ({ url: `/api/v1/admin/bot-commands` }),
    }),
    botCommandsAdminControllerGetBotCommandV1: build.query<
      BotCommandsAdminControllerGetBotCommandV1ApiResponse,
      BotCommandsAdminControllerGetBotCommandV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/bot-commands/${queryArg.id}`,
      }),
    }),
    botCommandsAdminControllerUpdateBotCommandV1: build.mutation<
      BotCommandsAdminControllerUpdateBotCommandV1ApiResponse,
      BotCommandsAdminControllerUpdateBotCommandV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/bot-commands/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateBotCommandBody,
      }),
    }),
    botCommandsAdminControllerDeleteBotCommandV1: build.mutation<
      BotCommandsAdminControllerDeleteBotCommandV1ApiResponse,
      BotCommandsAdminControllerDeleteBotCommandV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/bot-commands/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    botCommandsAdminControllerRestoreBotCommandV1: build.mutation<
      BotCommandsAdminControllerRestoreBotCommandV1ApiResponse,
      BotCommandsAdminControllerRestoreBotCommandV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/bot-commands/${queryArg.id}/restore`,
        method: 'POST',
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type BotCommandsAdminControllerCreateBotCommandV1ApiResponse =
  /** status 200 Returns created bot command */ CreateBotCommandResponse;
export type BotCommandsAdminControllerCreateBotCommandV1ApiArg = {
  createBotCommandBody: CreateBotCommandBody;
};
export type BotCommandsAdminControllerListBotCommandsV1ApiResponse =
  /** status 200 Returns the list of bot commands */ ListBotCommandsResponse;
export type BotCommandsAdminControllerListBotCommandsV1ApiArg = void;
export type BotCommandsAdminControllerGetBotCommandV1ApiResponse =
  /** status 200 Bot command details */ GetBotCommandResponse;
export type BotCommandsAdminControllerGetBotCommandV1ApiArg = {
  id: number;
};
export type BotCommandsAdminControllerUpdateBotCommandV1ApiResponse =
  /** status 200 Returns updated bot command */ UpdateBotCommandResponse;
export type BotCommandsAdminControllerUpdateBotCommandV1ApiArg = {
  id: number;
  updateBotCommandBody: UpdateBotCommandBody;
};
export type BotCommandsAdminControllerDeleteBotCommandV1ApiResponse =
  /** status 200 Returns deleted bot command */ DeleteBotCommandResponse;
export type BotCommandsAdminControllerDeleteBotCommandV1ApiArg = {
  id: number;
};
export type BotCommandsAdminControllerRestoreBotCommandV1ApiResponse =
  /** status 200 Returns restored bot command */ RestoreBotCommandResponse;
export type BotCommandsAdminControllerRestoreBotCommandV1ApiArg = {
  id: number;
};
export type CreateBotCommandResponse = {
  /** Bot Command ID */
  id: number;
  /** Bot command key (1-32 chars, lowercase, numbers, underscores) */
  key: string;
  /** Bot command value */
  value: null | string;
  /** Bot command description */
  description: null | string;
  /** Bot command category (used for grouping in /help) */
  category: 'info' | 'marketing' | 'calendly' | 'exchange_videos' | 'system';
  /** Bot command status: 1 enabled, 0 disabled, -1 deleted (soft delete) */
  status: number;
  /** System command implemented in bot code; cannot be deleted, only disabled */
  isSystem: boolean;
  /** Total number of times this command has been invoked */
  usageCount: number;
  /** Last time this command was used (null if never used) */
  lastUsedAt: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
};
export type CreateBotCommandBody = {
  /** Bot command key (1-32 chars, lowercase, numbers, underscores) */
  key: string;
  /** Bot command value */
  value?: null | string;
  /** Bot command description */
  description?: null | string;
  /** Bot command category (used for grouping in /help) */
  category?: 'info' | 'marketing' | 'calendly' | 'exchange_videos' | 'system';
};
export type ListBotCommandsResponse = {
  /** Bot Command ID */
  id: number;
  /** Bot command key (1-32 chars, lowercase, numbers, underscores) */
  key: string;
  /** Bot command value */
  value: null | string;
  /** Bot command description */
  description: null | string;
  /** Bot command category (used for grouping in /help) */
  category: 'info' | 'marketing' | 'calendly' | 'exchange_videos' | 'system';
  /** Bot command status: 1 enabled, 0 disabled, -1 deleted (soft delete) */
  status: number;
  /** System command implemented in bot code; cannot be deleted, only disabled */
  isSystem: boolean;
  /** Total number of times this command has been invoked */
  usageCount: number;
  /** Last time this command was used (null if never used) */
  lastUsedAt: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
}[];
export type GetBotCommandResponse = {
  /** Bot Command ID */
  id: number;
  /** Bot command key (1-32 chars, lowercase, numbers, underscores) */
  key: string;
  /** Bot command value */
  value: null | string;
  /** Bot command description */
  description: null | string;
  /** Bot command category (used for grouping in /help) */
  category: 'info' | 'marketing' | 'calendly' | 'exchange_videos' | 'system';
  /** Bot command status: 1 enabled, 0 disabled, -1 deleted (soft delete) */
  status: number;
  /** System command implemented in bot code; cannot be deleted, only disabled */
  isSystem: boolean;
  /** Total number of times this command has been invoked */
  usageCount: number;
  /** Last time this command was used (null if never used) */
  lastUsedAt: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
};
export type UpdateBotCommandResponse = {
  /** Bot Command ID */
  id: number;
  /** Bot command key (1-32 chars, lowercase, numbers, underscores) */
  key: string;
  /** Bot command value */
  value: null | string;
  /** Bot command description */
  description: null | string;
  /** Bot command category (used for grouping in /help) */
  category: 'info' | 'marketing' | 'calendly' | 'exchange_videos' | 'system';
  /** Bot command status: 1 enabled, 0 disabled, -1 deleted (soft delete) */
  status: number;
  /** System command implemented in bot code; cannot be deleted, only disabled */
  isSystem: boolean;
  /** Total number of times this command has been invoked */
  usageCount: number;
  /** Last time this command was used (null if never used) */
  lastUsedAt: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
};
export type UpdateBotCommandBody = {
  /** Bot command value */
  value?: null | string;
  /** Bot command description */
  description?: null | string;
  /** Bot command category (used for grouping in /help) */
  category?: 'info' | 'marketing' | 'calendly' | 'exchange_videos' | 'system';
  /** Bot command status: 1 enabled, 0 disabled, -1 deleted (soft delete) */
  status?: number;
};
export type DeleteBotCommandResponse = {
  /** Bot Command ID */
  id: number;
  /** Bot command key (1-32 chars, lowercase, numbers, underscores) */
  key: string;
  /** Bot command value */
  value: null | string;
  /** Bot command description */
  description: null | string;
  /** Bot command category (used for grouping in /help) */
  category: 'info' | 'marketing' | 'calendly' | 'exchange_videos' | 'system';
  /** Bot command status: 1 enabled, 0 disabled, -1 deleted (soft delete) */
  status: number;
  /** System command implemented in bot code; cannot be deleted, only disabled */
  isSystem: boolean;
  /** Total number of times this command has been invoked */
  usageCount: number;
  /** Last time this command was used (null if never used) */
  lastUsedAt: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
};
export type RestoreBotCommandResponse = {
  /** Bot Command ID */
  id: number;
  /** Bot command key (1-32 chars, lowercase, numbers, underscores) */
  key: string;
  /** Bot command value */
  value: null | string;
  /** Bot command description */
  description: null | string;
  /** Bot command category (used for grouping in /help) */
  category: 'info' | 'marketing' | 'calendly' | 'exchange_videos' | 'system';
  /** Bot command status: 1 enabled, 0 disabled, -1 deleted (soft delete) */
  status: number;
  /** System command implemented in bot code; cannot be deleted, only disabled */
  isSystem: boolean;
  /** Total number of times this command has been invoked */
  usageCount: number;
  /** Last time this command was used (null if never used) */
  lastUsedAt: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
};
